import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from "react";
import Script from "next/script";
const JWPlayerContext = /*#__PURE__*/ React.createContext({
    player: null
});
export const JWPlayerProvider = (param)=>{
    let { children  } = param;
    const [jwplayer, setJwplayer] = useState(null);
    return /*#__PURE__*/ _jsxs(JWPlayerContext.Provider, {
        value: {
            player: jwplayer
        },
        children: [
            /*#__PURE__*/ _jsx(Script, {
                src: "https://cdn.jwplayer.com/libraries/GQoshPfT.js",
                strategy: "afterInteractive",
                onLoad: ()=>{
                    setJwplayer(()=>window.jwplayer);
                }
            }),
            children
        ]
    });
};
export const useJWPlayer = ()=>useContext(JWPlayerContext).player;
